/* eslint-disable react/no-array-index-key */

import Button from 'components/Button'
import Card from 'components/Card'
import CardFooter from 'components/CardFooter'
import { Column, Row } from 'components/Grid'
import Heading from 'components/Heading'
import Loading from 'components/Loading'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './PersonalInfo.scss'
// import moment from 'moment'
import { format } from 'date-fns'
import constants from 'constants'
import PartnerChildrenList from './components/PartnerChildren'
import FeatureGuard from '../../components/FeatureToggle/FeatureGuard'

class PersonalInfoView extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    deletePartnerChildren: PropTypes.func.isRequired,
    getPersonalInfo: PropTypes.func,
    // eslint-disable-next-line react/no-unused-prop-types
    isAdmin: PropTypes.object,
    openPartnerChildrenForm: PropTypes.func.isRequired,
    personalInfo: PropTypes.object.isRequired,
  }
  static defaultProps = {
    getPersonalInfo: null,
  }

  getPersonalInfo = () => {
    this.props.getPersonalInfo('error')
  }

  render() {
    const {
      personalInfo,
      showEditLink,
      currentUser,
      deletePartnerChildren,
      openPartnerChildrenForm,
    } = this.props

    const YesNo = {
      true: 'Yes',
      false: 'No',
    }

    if (!personalInfo.isFetching && personalInfo.personalInfo && personalInfo.personalInfo.length > 0) {
      return (
        <FeatureGuard featureName="Personal Info" user={currentUser}>
          <div>
            <Row>
              <Column base={6} layout={12}>
                <section className={styles.section}>
                  <Heading className={styles.sectionTitle}>Personal data</Heading>
                  <Card noPadding className={styles.baseCard}>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Preferred Name</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].preferred_name) ? personalInfo.personalInfo[0].preferred_name : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Other Name</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].other_name) ? personalInfo.personalInfo[0].other_name : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Gender</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].gender) ? personalInfo.personalInfo[0].gender : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Date of Birth</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].birth_date) ? format(new Date(personalInfo.personalInfo[0].birth_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Place of Birth</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].birth_place) ? personalInfo.personalInfo[0].birth_place : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.line} />
                    </div>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>TFN</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].TFN) ? personalInfo.personalInfo[0].TFN : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Primary cost centre Code</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].cost_centre_code) ? personalInfo.personalInfo[0].cost_centre_code : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Status</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].status) ? 'Active' : 'Inactive'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Job Code</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].job_code) ? personalInfo.personalInfo[0].job_code : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Cost centre effective date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].cost_centre_effective_date) ? format(new Date(personalInfo.personalInfo[0].cost_centre_effective_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>PeopleSoft Company</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].peoplesoft_company) ? personalInfo.personalInfo[0].peoplesoft_company : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.line} />
                    </div>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>EPIC draw down start date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].draw_down_start_date) ? format(new Date(personalInfo.personalInfo[0].draw_down_start_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>EPIC draw down end date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].draw_down_end_date) ? format(new Date(personalInfo.personalInfo[0].draw_down_end_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Business title</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].business_title) ? personalInfo.personalInfo[0].business_title : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Seconded to</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].seconded_to) ? personalInfo.personalInfo[0].seconded_to : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Date of Admission</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].DateofAdmissiontoPartnership) ? format(new Date(personalInfo.personalInfo[0].DateofAdmissiontoPartnership), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Date of retirement</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].retirement_date) ? format(new Date(personalInfo.personalInfo[0].retirement_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Board Member</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].board_member !== null) ? YesNo[personalInfo.personalInfo[0].board_member] : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Antecedent date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].antecedent_date) ? format(new Date(personalInfo.personalInfo[0].antecedent_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Antecendent name</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].antecedent_name) ? personalInfo.personalInfo[0].antecedent_name : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Pension accrual date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].pension_accrual_date) ? format(new Date(personalInfo.personalInfo[0].pension_accrual_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Pension commencement date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].DateofCommencementofPension) ? format(new Date(personalInfo.personalInfo[0].DateofCommencementofPension), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Pension end date</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].EndDateofPensionPayments) ? format(new Date(personalInfo.personalInfo[0].EndDateofPensionPayments), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.line} />
                    </div>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Director id</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].director_id) ? personalInfo.personalInfo[0].director_id : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Allocated partner tax manager</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].allocated_partner_tax_manager) ? personalInfo.personalInfo[0].allocated_partner_tax_manager : '-'}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {(showEditLink ?
                      <CardFooter>
                        <Button className={styles.editPersonalInfo} onClick={this.props.openEditPersonalInfoView} type="flat">
                        Edit
                      </Button>
                      </CardFooter> : <div />)}
                  </Card>
                </section>
              </Column>
              <Column base={6} layout={12}>
                <section className={styles.section}>
                  <Heading className={styles.sectionTitle}>Contact info</Heading>
                  <Card noPadding className={styles.baseCard}>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Phone number (work)</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].work_phone_number) ? personalInfo.personalInfo[0].work_phone_number : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Mobile number</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].cellular_number) ? personalInfo.personalInfo[0].cellular_number : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Phone number (home)</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_phone_number) ? personalInfo.personalInfo[0].home_phone_number : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Email</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].email_id) ? personalInfo.personalInfo[0].email_id : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.line} />
                    </div>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Home address line 1</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_address_field_1) ? personalInfo.personalInfo[0].home_address_field_1 : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Home address line 2</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_address_field_2) ? personalInfo.personalInfo[0].home_address_field_2 : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Suburb</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_address_field_3) ? personalInfo.personalInfo[0].home_address_field_3 : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>City</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_city) ? personalInfo.personalInfo[0].home_city : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>State</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_state) ? personalInfo.personalInfo[0].home_state : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Postcode</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_postcode) ? personalInfo.personalInfo[0].home_postcode : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Country</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].home_country) ? personalInfo.personalInfo[0].home_country : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.line} />
                    </div>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Mailing address line 1</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_address_field_1) ? personalInfo.personalInfo[0].mailing_address_field_1 : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Mailing address line 2</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_address_field_2) ? personalInfo.personalInfo[0].mailing_address_field_2 : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Suburb</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_address_field_3) ? personalInfo.personalInfo[0].mailing_address_field_3 : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>City</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_city) ? personalInfo.personalInfo[0].mailing_city : '-'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className={styles.right}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>State</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_state) ? personalInfo.personalInfo[0].mailing_state : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Postcode</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_postcode) ? personalInfo.personalInfo[0].mailing_postcode : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Country</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].mailing_country) ? personalInfo.personalInfo[0].mailing_country : '-'}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Card>
                </section>
                <section className={styles.section}>
                  <Heading className={styles.sectionTitle}>Spouse details</Heading>
                  <Card noPadding className={styles.baseCard}>
                    <div className={styles.personalInfoWrapper}>
                      <div className={styles.left}>
                        <ul className={styles.list}>
                          <li>
                            <span className={styles.label}>Spouse full legal name</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].spouse_partner_name) ? personalInfo.personalInfo[0].spouse_partner_name : '-'}</span>
                          </li>
                          <li>
                            <span className={styles.label}>Spouse date of birth</span>
                            <span className={styles.detail}>{(personalInfo.personalInfo[0].spouse_partner_birth_date) ? format(new Date(personalInfo.personalInfo[0].spouse_partner_birth_date), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH) : '-'}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Card>
                </section>
              </Column>
            </Row>
            <section className={styles.section}>
              <PartnerChildrenList
                currentUser={currentUser}
                deletePartnerChildren={deletePartnerChildren}
                openPartnerChildrenForm={openPartnerChildrenForm}
                partnerChildrenItems={personalInfo.partnerchildrens}
                personalInfo={personalInfo}
            // getBeneficiaries={this.props.getBeneficiaries}
            // beneficiary={this.props.beneficiaries.beneficiary}
                showEditLink={showEditLink}
              />
            </section>
          </div>
        </FeatureGuard>
      )
    }

    return (<Loading pageLoading />)
  }
}

export default PersonalInfoView



// WEBPACK FOOTER //
// ./src/views/PersonalInfo/PersonalInfoView.js